import { useQuery } from "@tanstack/react-query";
import { fetchGuestSecurity } from "../api/guestAuth";
export default function useGuestSecurity() {
  return useQuery({
    queryKey: ["guest-auth-security"],
    queryFn: fetchGuestSecurity,
    retry: false,
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}
